import { CanvasManager } from "./CanvasManager";
import { CanvasScene } from "./CanvasScene";
import { Cell } from "./Cell";
import { CellsPool } from "../../utils/CellsPool";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { MyPoint } from "../../../typescript/MyPoint";
import { Utils } from "phaser";
import { GeneralUtils } from "../../utils/Utils";

export class Board extends Phaser.GameObjects.Container {

    public currentScene: CanvasScene;
    public boardOrigin: MyPoint;

    constructor(scene: CanvasScene) {
        super(scene);

        this.currentScene = scene;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        this.scaleX = GameVars.scaleXMult;
        this.scaleY = GameVars.scaleYMult;

        this.boardOrigin = new MyPoint(-CanvasManager.widthInPixels / 2, - CanvasManager.heightInPixels / 2);
    }

    public createDrawing() {
        this.generateTiles();
    }

    public resetDrawing() {
        this.clearTiles();
    }

    private clearTiles(): void {

        for (let y = 0; y < CanvasManager.heightInCells; y++) {

            for (let x = 0; x < CanvasManager.widthInCells; x++) {

                const cell: Cell = GameVars.pixelTiles[y][x];
                if (cell) {
                    cell.cellReset();
                }
            }
        }
    }

    private generateTiles(): void {

        GameVars.pixelTiles = [];
        let idCount = 0;

        const lightColours: { [key: number]: boolean } = {};

        for (let y = 0; y < CanvasManager.heightInCells; y++) {

            GameVars.pixelTiles[y] = [];

            for (let x = 0; x < CanvasManager.widthInCells; x++) {

                // Get pixel color from color image and GS image
                let currentPixel = GameVars.pixelTilesCode[y][x];
                let grayScalePixel = GameVars.pixelTilesCodeGrayscale[y][x];

                if (currentPixel == null || grayScalePixel == null) {
                    idCount++;
                    continue;
                }

                // If the alpha is 0 we don't generate any cell
                if (currentPixel.alpha <= 0) {
                    GameVars.pixelTiles[y].push(null);
                    idCount++;
                    continue;
                }

                let isLightColour = false;
                if (lightColours.hasOwnProperty(currentPixel.color)) {
                    isLightColour = lightColours[currentPixel.color];
                } else {

                    const colourBgDiff = GeneralUtils.colourDistance(currentPixel.red, currentPixel.green, currentPixel.blue,
                        255, 255, 255);

                    isLightColour = colourBgDiff < 80;
                    lightColours[currentPixel.color] = isLightColour;
                }

                // If alpha != 0, then create a Tile with that color and needed ID.
                const newCell: Cell = CellsPool.getCell();
                newCell.setData(this.boardOrigin.x + x * 32, this.boardOrigin.y + y * 32, this, currentPixel, grayScalePixel, true, idCount, isLightColour);

                // newCell.createCallbacks(CanvasManager.currentScene);   
                GameVars.pixelTiles[y].push(newCell);

                // Add tile counter 
                CanvasManager.tilesAmmount++;
                idCount++;
            }
        }

        for (let i = 0; i < GameVars.colorCount.length; i++) {
            GameVars.colorCountMax[i] = GameVars.colorCount[i];
        }
    }
}
